import React from 'react';
import {WithTranslationProps} from 'react-i18next';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

interface ActivationDateProps extends WithTranslationProps {
  item: {
    activatedOn?: string | null;
  };
}

export const ActivationDate: React.FC<ActivationDateProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = {},
}) => {
  const activationDate = get(item, 'activatedOn', {});
  return tt(
    'activationDate',
    generateComponentCallback({
      component: (
        <Text testID={Reports.reportActivatedOn}>
          Activation Date:{' '}
          {getDateUtilDefaultInstance().formatDate(
            activationDate,
            'MMMM d, yyyy',
          )}
        </Text>
      ),
    }),
  );
};

export default withTranslation('report.record.activationDate')(ActivationDate);
